module.exports = __webpack_public_path__ + "application/templates/default/inner/otherwise/otherwise.template.html";